import { createFileRoute } from '@tanstack/react-router'
import { TaskDetailView } from '@/components/task-detail-view'
import { useTask } from '@/hooks/use-task-queries'

export const Route = createFileRoute('/dashboard/task/$taskId/')({
    component: TaskDetailPage,
})

function TaskDetailPage() {
    const { taskId } = Route.useParams()
    const { data: task } = useTask(taskId)

    if (!task) {
        return null
    }

    return <TaskDetailView task={task} />
}
